module.exports = __webpack_public_path__ + "static/media/Q.e686fbf7.svg";